export default {
  nav: {
    home: '首页',
    appIntro: 'APP介绍',
    aboutUs: '关于我们',
  },
  mobileNav: {
    home: '首页',
    fruit: '生鲜果蔬',
    productMicro: '产品微观',
    features: '产品特点',
    partners: '合作伙伴',
    aboutUs: '关于我们',
  },
  footer: {
    contact: '联系方式：jinzekeji09@163.com',
    company: '公司：金遥国际有限公司',
    appDownload: 'APP下载',
  },
  home: {
    productIntroTitle: '彩虹短剧介绍',
    productIntroSubtitle: '彩虹短剧满足多类用户需求',
    productIntroContent: [
      '首页主播分类展示 选择顶部分类可查看对应主播',
      '点击主播头像可查看主播的照片和视频信息',
      '动态查看用户发布的动态消息，也可对动态进行评论点赞',
      '消息 可以和系统内的主播进行视频语音聊天',
    ],
    manageTitle: '管理平台',
    manageContent: [
      '系统管理 控制APP的落地页配置和版本配置',
      '用户管理 用户自定义标签，了解用户消费行为',
      '财务管理 实时掌握用户的会员状态',
      '活动推广 实时掌握拉新排行榜',
      '意见反馈 积极处理用户对app的使用体验',
    ],
    aboutUsTitle: '关于我们',
    aboutUsContent: [
      '企业从事于：互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。',
      '核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。',
      '团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。',
      '企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。',
    ],
    serviceFlowTitle: '服务流程',
    partnersTitle: '合作伙伴',
  },
  fruit: {
    title: '拥有自己的外卖平台',
    subtitle: '为商家快速搭建专业的外卖平台 圈住门店半径5公里内的微信用户',
    delivery: {
      rangeTitle: '自定义配送范围',
      rangeContent: '商家后台自定义配送范围',
      customTitle: '支持自定义配送',
      customContent: '商家自己优选配送路径',
      couponTitle: '线上优惠券福利',
      couponContent: '各种优惠福利提升用户消费',
    },
  },
  top: 'TOP',
  intro: {
    heroTitle: '全球短剧合作伙伴中心',
    heroSubtitle: '加入增长最快的娱乐生态系统。赚取佣金、组建团队，抓住十亿美元的短剧浪潮。',
    statGrowth: '市场增长（三年）',
    statDramas: '授权剧集',
    statMonthly: '头部合伙人月收入',
    statLanguages: '语言市场',
    navIntro: '平台介绍',
    navCases: '成功案例',
    navCommission: '佣金体系',
    navEpisodes: '剧集列表',
    navCompliance: '合规要求',
    introTag: '关于彩虹短剧',
    introTitle: '彩虹短剧平台介绍',
    introSubtitle: '全球短剧革命已经到来——彩虹短剧正处于其中心。',
    introParas: [
      '彩虹短剧（RainBow Short）正处于全球短剧热潮的中心。这是一个由技术创新和消费行为变化共同驱动的蓝海市场。从中国的全国热潮，到美国ReelShort的快速崛起，再到东南亚九州短剧的流行，短剧正在重塑全球娱乐格局。每分钟都有人在为这些1-3分钟的沉浸式内容付费。数据显示，这个市场在未来三年将增长超过300%，现在正是进入的最佳时机。',
      '技术突破正在让这个行业更加令人兴奋。AI漫画技术正在将小说自动转化为视觉内容，大幅降低生产成本的同时显著提高效率。AI真人短剧使用智能换脸和语音合成技术，消除了传统制作限制。互动故事情节进一步将用户从观众转变为参与者，显著提高付费意愿。',
      '全球成功案例：ReelShort以本地化豪门剧情打开美国市场，日收入屡创新高；九州短剧深耕东南亚本土文化，形成稳定的付费社群；中国成熟的商业模式已经证明了这种形式的强大变现能力。',
      '更值得注意的是，短剧分销正在创造惊人的财富效应。在中国，头部分销合伙人月收入可达数十万元人民币；在海外，许多人通过推广ReelShort等平台实现了月收入超过1万美元。我们平台上的合伙人，有些在三个月内从零增长到月入5000美元以上，有些在东南亚月佣金超过15000美元。',
      '我们为合伙人提供全面的运营支持系统：每位合伙人配备专属AI销售助手，可24/7跟进潜在客户；视频矩阵系统一键生成多平台短视频内容；12种语言推广物料；每周实战培训；一对一创业扶持计划。',
      '加入彩虹短剧不仅仅是推广一款产品，更是抓住一个快速增长的全球趋势。在这里，您可以建立自己的数字资产，积累长期收入，最终实现时间自由和财务自由。',
    ],
    casesTag: '真实合伙人，真实成绩',
    casesTitle: '成功案例',
    casesSubtitle: '这些不是宣传故事——而是通过短剧分销改变生活的真实合伙人。',
    commissionTag: '收益结构',
    commissionTitle: '短剧APP合伙人佣金机制',
    commissionSubtitle: '官方公开版本——透明、公平、可追溯。所有权益公开落地执行。',
    partner1Title: '销售合伙人（分销合伙人）',
    partner1Desc: '免费注册，零门槛零费用。参与推广短剧即可赚取佣金，无需购买任何服务套餐。即刻享受基础推广权益。',
    partner2Title: '区域销售顾问',
    partner2Desc: '购买平台2980元运营服务套餐，即可享受完整推广权益、全面运营支持，并获得平台团队业绩补贴资格。',
    searchPlaceholder: '按标题、类型或描述搜索...',
    download: '下载',
    noResults: '没有匹配的剧集。',
    episodesTag: '35部授权剧集',
    episodesTitle: 'Briz授权剧集列表',
    episodesSubtitle: 'Briz自有版权授权剧集单（共35部）— 浏览所有可用剧集的下载链接和剧情简介。',
    complianceTag: '合伙人行为规范',
    complianceTitle: '合规要求',
    complianceSubtitle: '所有合伙人须遵守以下行为标准，维护平台形象。',
    footerTagline: '全球合伙人资源中心',
    footerNote: '机会不等待观望者——成功属于行动者。',
    complianceItems: [
      '严禁夸大宣传。不得使用"轻松赚钱"、"无风险高收益"、"稳赚不赔"、"快速致富"等虚假宣传。',
      '严禁以拉人头、发展下线为主要盈利模式。所有收益须基于真实用户充值消费。',
      '严禁虚假宣传、虚假充值刷单、恶意刷量、伪造业绩等行为。',
      '不得使用违法违规、低俗、侵权内容进行推广。所有行为须符合当地法律法规。',
      '严禁以平台名义进行非法集资、传销、诈骗等违法活动。',
      '合伙人须自觉维护平台品牌形象。违规行为可能导致佣金冻结、合伙人资格取消及进一步追责。',
    ],
    commissionBlocks: [
      {
        title: '二、佣金计算基数规则',
        items: [
          '平台可结算收益来源包括：APP广告收益和用户订阅收益（月卡、季卡、年卡会员）。',
          '所有佣金、补贴、奖金的计算基数为扣除Google和Apple应用商店30%渠道分成后的实际可结算金额。',
        ],
      },
      {
        title: '三、销售合伙人——两级分销佣金',
        items: [
          '<strong style="color:#fff">直接推荐（30%）：</strong>当销售合伙人直接推荐的用户在平台完成短剧充值消费时，合伙人获得该笔交易有效结算基数的30%。',
          '<strong style="color:#fff">间接推荐（20%）：</strong>由合伙人直接推荐的销售合伙人或区域销售顾问所推广的用户，当该用户完成实际充值消费时，销售合伙人获得有效结算基数的20%。',
        ],
      },
      {
        title: '四、区域销售顾问——额外权益',
        items: [
          '<strong style="color:#fff">完整销售合伙人权益：</strong>两级分销佣金（直推40%+间推20%）及服务套餐推荐奖励，规则与销售合伙人一致。',
          '<strong style="color:#fff">推荐人销售辅导奖金（10%）：</strong>若区域销售顾问直接推荐另一人成为区域销售顾问，则可获得该顾问推广佣金收入10%的奖金（不含服务套餐推荐奖励）。',
          '<strong style="color:#fff">有效期限：</strong>自被推荐顾问激活之日起计算，有效期6个月，到期自动终止。',
          '奖金包含被推荐顾问的分销佣金和团队业绩补贴，按月核算发放。',
        ],
      },
      {
        title: '五、统一佣金结算规则',
        items: [
          '所有佣金、补贴、奖金均基于用户实际到账且有效的充值金额计算。',
          '退款订单、取消订单、虚假充值、刷单等无效业绩不计入结算。',
          '佣金按规则实时计算，按平台结算周期发放。详细收益可在个人后台查看。',
        ],
      },
      {
        title: '七、其他规定',
        items: [
          '间推奖励和辅导奖金仅限一级，不跨多层延伸。',
          '2980元运营服务套餐为付费运营支持服务，购买后不可退款。',
          '团队业绩补贴仅限区域销售顾问享受，销售合伙人不具备此资格。',
          '平台有权根据实际运营情况对佣金体系、权益及结算规则进行优化调整，调整将提前公告。',
          '本合伙人佣金机制最终解释权归平台所有。',
        ],
      },
    ],
    cases: [
      { location: '🌏 东南亚', income: '$15,000-$20,000/月', desc: '一位家庭主妇利用业余时间分享以当地喜欢豪门逆袭的女性为目标的短剧内容，通过Facebook妈妈群和TikTok推广，6个月内扩展到5人团队。' },
      { location: '🇩🇪🇫🇷 欧洲', income: '€50,000/月', desc: '一个3人的欧洲团队运用数据分析，发现德国用户偏好商战剧情而法国用户喜欢言情剧。9个月内月佣金从€3,000增长到€50,000。' },
      { location: '🌍 中东', income: '$80,000+/月', desc: '一位创业者在Gulf国家建立了本地化运营团队，根据文化特色定制内容。一年后月佣金超过$80,000。' },
      { location: '🌎 拉美', income: '$45,000/月', desc: '一位拥有100万+粉丝的创作者通过直播解说和独家幕后内容整合短剧推广。5个月内月收入达到$45,000。' },
      { location: '🌏 亚洲', income: '$30,000+/月被动收入', desc: '建立了自动化推广系统，智能识别热门剧集并生成多语言素材。每周维护不到10小时，每月产生超过$30,000的被动收入。' },
      { location: '🌏 东南亚', income: '$15,000-$20,000/月', desc: '一位夜班便利店工人针对夜间观众推广悬疑剧，通过TikTok在8个月内稳定收入。' },
      { location: '🇦🇪 迪拜', income: '$8,000-$12,000/月', desc: '一位商科学生运用营销知识，通过Instagram和WhatsApp瞄准海湾高净值人群，在建立校园团队的同时每月收入$8K-$12K。' },
      { location: '🇬🇧 英国', income: '£9,000/月', desc: '一位退休教师运用文学专业知识在Facebook社区讲解情感剧情。她的每日剧评专栏广受欢迎，7个月后月收入达到£9,000。' },
      { location: '🇲🇽 墨西哥', income: '$18,000-$25,000/月', desc: '一位平面设计师创作高转化推广封面，点击率提升300%。结合设计接单和个人账号实现月入$18K-$25K。' },
      { location: '🇸🇬 新加坡', income: '$16,000/月平均', desc: '建立热度预测模型，专注推广新上线的热门剧集。每天投入约1小时，实现月均佣金$16,000。' },
    ],
  },
};
